import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bed"
const BedIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.5 3.75C20.328 3.75 21 4.422 21 5.25V11.452C21.448 11.712 21.75 12.195 21.75 12.75V20.25H20.25V18H3.75V20.25H2.25V12.75C2.25 12.195 2.552 11.712 3 11.452V5.25C3 4.422 3.672 3.75 4.5 3.75zM3.75 16.5H20.25V12.75H3.75zM6 9C5.172 9 4.5 9.672 4.5 10.5V11.25H11.25V10.5C11.25 9.672 10.578 9 9.75 9zM14.25 9C13.422 9 12.75 9.672 12.75 10.5V11.25H19.5V10.5C19.5 9.672 18.828 9 18 9zM4.5 7.902C4.941 7.647 5.453 7.5 6 7.5H9.75C10.646 7.5 11.45 7.893 12 8.517 12.55 7.893 13.354 7.5 14.25 7.5H18C18.547 7.5 19.059 7.647 19.5 7.902V5.25H4.5z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BedIcon
